import { EventEmitter, Injectable } from '@angular/core';

import { BetslipListType } from '@frontend/sports/types/models/my-bets';

import { MyBetsSummaryService } from '../../my-bets-base/my-bets-summary.service';
import { MyBetsTab } from '../models/my-bets-tab';

@Injectable()
export class MyBetsTabsService {
    tabSelected: EventEmitter<MyBetsTab> = new EventEmitter<MyBetsTab>();
    betslipTabs: MyBetsTab[];

    private currentSelectedTab: MyBetsTab | null = null;

    private liveTab: MyBetsTab;
    private openTab: MyBetsTab;
    private settledTab: MyBetsTab;

    constructor(private myBetsSummary: MyBetsSummaryService) {
        this.liveTab = new MyBetsTab(BetslipListType.Live, () => this.myBetsSummary.summary.liveBetsCount);
        this.openTab = new MyBetsTab(BetslipListType.Open, () => this.myBetsSummary.summary.openBetsCount);

        this.settledTab = new MyBetsTab(BetslipListType.Settled, () => 0);
        this.betslipTabs = [this.liveTab, this.openTab, this.settledTab];
    }

    selectTab(tabType: BetslipListType): void {
        const target = this.findTabByType(tabType);
        this.selectedTab = target;
    }

    resetTabs() {
        this.betslipTabs.forEach((t) => (t.selected = false));
    }

    set selectedTab(value: MyBetsTab | null) {
        if (value) {
            this.betslipTabs.forEach((t) => (t.selected = false));
            this.currentSelectedTab = value;
            this.currentSelectedTab.selected = true;
            this.tabSelected.emit(this.currentSelectedTab);
        }
    }

    get activeTab(): MyBetsTab | null {
        return this.currentSelectedTab;
    }

    private findTabByType(tabType: BetslipListType): MyBetsTab | null {
        switch (tabType) {
            case BetslipListType.Live:
                return this.liveTab;
            case BetslipListType.Open:
                return this.openTab;
            case BetslipListType.Settled:
                return this.settledTab;
            default:
                return null;
        }
    }
}
